import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { BankAccount } from '../types/entities/BankAccount';

export const bankAccount: SchemaWithClient<BankAccount> = {
  name: 'Bank Account',
  pluralName: 'Bank Account',
  columns: {
    service_provider: {
      name: 'Service Provider',
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceProvider),
      switchboard: true,
      url: enumItems.serviceProvider.client.getAllPath,
      tempSchema: enumItems.serviceProvider,
    },
    guide: {
      name: 'Guide',
      fieldRenderer: SelectField.tableAdapter(enumItems.guide),
      switchboard: true,
      url: enumItems.guide.client.getAllPath,
      tempSchema: enumItems.guide,
    },
    sales_partner: {
      name: 'Sales Partner',
      fieldRenderer: SelectField.tableAdapter(enumItems.salesPartner),
      switchboard: true,
      url: enumItems.salesPartner.client.getAllPath,
      tempSchema: enumItems.salesPartner,
    },
    account_holder_name: {
      name: 'Account Holder Name',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    account_number: {
      name: 'Account Number',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    iban: {
      name: 'Iban',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    swift: {
      name: 'Swift',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    bank_name: {
      name: 'Bank Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    bank_address: {
      name: 'Bank Address',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/bank-accounts'),
};
